module.exports = __webpack_public_path__ + "static/media/Brands_8.046e3c28.png";